export default __webpack_public_path__ + "static/media/ref_outil.9f632c57.svg";